import { render } from "./inputfield.vue?vue&type=template&id=6b9666a6"
import script from "./inputfield.vue?vue&type=script&lang=js"
export * from "./inputfield.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__